import { snakeStore, SORT_DIRECTION, SORT_COLUMN } from '@/plugins/vuex-async-pagginate';
import { MessageService } from '@mailer/services/MessageService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => MessageService.getList(params)
    }
  },
  true
);
